import Image from "next/image";

const EngagementSectionBottomContent = () => {
  return (
    <div className="grid grid-cols-12 gap-y-6 md:gap-x-4 lg:gap-x-8">
      <div className="col-span-12 md:col-span-5 lg:col-span-6 flex justify-center">
        <div>
          <Image
            src="/images/haulers/engagement-02.png"
            alt="Market Details"
            width={560}
            height={444}
          />
        </div>
      </div>
      <div className="col-span-12 md:col-span-7 lg:col-span-6 flex flex-col justify-center items-center md:items-start space-y-6">
        <span className="mobile-h3 md:h4 lg:h3 text-center md:text-left">Operations Enhancement</span>
        <span className="p-6 md:max-w-[480px] border border-1 border-white/50 bg-black/20 rounded-lg shadow-2xl backdrop-blur-xl">
          SimpleWaste innovation creates fast-paced vendor engagement,
          streamlining opportunities to the most qualified participants. Access
          the right markets, bids, and details quickly.
        </span>
      </div>
    </div>
  );
};

export default EngagementSectionBottomContent;
